//#region Components
import NavigateButton from "components/NavigateButton/NavigateButton";
//#endregion
//#region Styles
import { 
    Row, 
    SubtitleSection } from "components/styles";
//#endregion

const PageManager = ({
    caption,
    isFreeCaption = false,
    width,
    noPages = false,
    dataPaginator: {
        quantityPages,
        currentPage = "?",
        setCurrentPage,
        nextPage, backPage
    }
}) => {
    const isInvalidData = () => (currentPage === 0 && currentPage === quantityPages) || quantityPages < currentPage;
    return (
        <Row justifyContent="flex-end" width={width}>
            {!isInvalidData() && 
            <SubtitleSection fontWeight="400">
                {isFreeCaption 
                ? caption
                : `${caption} ${!noPages && `${currentPage} de ${quantityPages}`}`}
            </SubtitleSection>}
            <Row gap="5px">
                <NavigateButton 
                    onClick={() => backPage ? backPage() : setCurrentPage(currentPage - 1)} 
                    angle="90deg"
                    disabled={noPages || currentPage === 1 || isInvalidData()}/>
                <NavigateButton
                    onClick={() => nextPage ? nextPage() : setCurrentPage(currentPage + 1)}
                    angle="270deg"
                    disabled={noPages || currentPage >= quantityPages || isInvalidData()}/>
            </Row>
        </Row>
    );
}

export default PageManager;